<template>
    <div>

        <!-- Grid view button -->

        <a :href="'../' + phase.id" class="btn btn-white btn-sm mb-4">
            <i class="material-icons" style="position:relative;top:-1px;margin-right:5px;">apps</i>
            {{ lang.polaris.dashboard.grid_view }}
        </a>

        <!-- Customize button -->

        <a :href="'../' + phase.id + '/custom'" class="btn btn-white btn-sm mb-4" v-if="customPermission && customStatus">
            <i class="material-icons" style="position:relative;top:-1px;margin-right:5px;">grid_on</i>
            {{ lang.polaris.dashboard.customize }}
        </a>
        <div class="mt-3" v-else></div>

        <!-- Struct -->

        <enac-atpl-dashboard-phase-signatures-map :id="id" :bus="bus">
        </enac-atpl-dashboard-phase-signatures-map>

        <!-- Details modal -->

        <trax-ui-modal-plain-header :id="id+'-details'" :bus="bus">
            <enac-atpl-dashboard-phase-item-details :id="id+'-details'" :bus="bus">
            </enac-atpl-dashboard-phase-item-details>
        </trax-ui-modal-plain-header>

    </div>
</template>

<script>
    export default {
    
        props: {
            id: {default: 'enac-atpl-dashboard-phase-items'}
        },
    
        data: function() {
            return {
                lang: lang,
                user: user,
                registration: data.registration,
                phase: data.phase,
                location: window.location,
                bus: new Vue()
            }
        },

        computed: {

            customPermission: function() {
                return this.user.admin || this.user.permissions['dashboard.customize-phases']
                     || this.user.permissions['dashboard.customize-collective-path'] 
            },

            customStatus: function() {
                return this.registration.status != 'archived';
            }
        }
    }
</script>
